module.exports = __webpack_public_path__ + "img/training.2cf2db61.svg";